export enum ProjetoTipo {
  REURB_TRADICIONAL = 'REURB_TRADICIONAL',
  REURB_TITULATORIO = 'REURB_TITULATORIO',
  REURB_INTERMEDIACAO = 'REURB_INTERMEDIACAO',
  AVERBACAO = 'AVERBACAO'
};

export enum ProjetoCategoria {
  PADRAO = 'PADRAO',
  CDHU = 'CDHU',
};